<template>
  <div id="msgBtn">
    <div id="helloBar" ref="helloBar">
      <transition name="slideRight">
        <div class="msgIcon" v-if="!flag">
          <div class="msgBack" @click="isActive">
            <Badge :count="Number(Alength+$store.state.app.signiNum)">
              <Icon type="ios-notifications" size="26" class="iconMsg" style="margin-top: 3px;" />
            </Badge>
          </div>
        </div>
      </transition>
      <transition name="slideRight">
        <div class="msgBox" v-if="flag" @mouseout="clearNotiNum">
          <div class="infoLeft">
            <ul>
              <li @click="ulShow=true" :class="ulShow ?liClass:''">
                <i>
                  <img src="../../../static/img/notice/info.png" width="100%" />
                </i>
                <p>
                  报警
                  <span style="font-weight:blod;">({{Alength}})</span>
                </p>
              </li>
              <li @click="ulShow=false" :class="!ulShow ?liClass:''">
                <i>
                  <img src="../../../static/img/notice/info.png" width="100%" />
                </i>
                <p>签约({{$store.state.app.signiNum}})</p>
              </li>
            </ul>
            <button class="btnYD" v-show="ulShow" @click="allRead()">一键已读</button>
            <div class="flod" @click="isActive">
              <img src="../../../static/img/notice/fold.png" width="100%" />
            </div>
          </div>
          <ul class="infoRight" v-show="ulShow">
            <li v-for="(item,index) in alarmInfo" :key="index" @click="detail(item)">
              <p class="poptip">车辆:{{item.carId}}报警</p>
              <b>报警时间:{{item.alarmTime}}</b>
              <i></i>
            </li>
          </ul>
          <ul class="infoRight" v-show="!ulShow">
            <li v-for="(item,index) in $store.state.app.signData" :key="index" @click="Sign(item)">
              <p class="poptip">产生单位:{{item.unitName}}</p>
              <i></i>
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import "../../../static/js/moveElement.js";
import moment from "moment";
export default {
  name: "notificationBar",
  data() {
    return {
      liClass: "liClass",
      ulShow: true,
      notiNum: 0,
      signiNum: 0,
      flag: false,
      alarmInfo: [],
      Alength: "",
    };
  },

  methods: {
    // 一键已读
    allRead() {
      let that = this;
      this.$req.post("", api.url_alarm_info_allRead, function (_r, _x) {
        if (_r.success == true) {
          if (_r.data) {
            that.$util._notify.success("操作成功！");
            that.refAkarninfo();
          }
        }
      });
    },
    shijian(date) {
      return moment.unix(date).format("YYYY-MM-DD HH:mm:ss");
    },
    detail(param) {
      //查看报警详情
      this.$emit("notificationDetail", param, 111);
    },
    Sign(param) {
      //查看产生单位签约详情
      this.$emit("singDataShow", param, 222);
    },
    clearNotiNum() {
      //清空消息数量
      this.$store.commit("setNotiNum", 0);
      this.$store.commit("setSigniNum", 0);
    },
    isActive() {
      let that = this;
      if (this.flag) {
        //消息关闭
        this.flag = false;
        this.$nextTick(function () {
          var msgBtn = document.getElementById("msgBtn"),
            msgIcon = document.getElementsByClassName("msgIcon")[0],
            func2 = moveElement.add(msgBtn, msgIcon); //为【msgBtn】添加移动功能，【msgHead】为鼠标拖动区域

          msgIcon.onmousedown = function () {
            msgIcon.onmousedown = null;
          };
        });
      } else {
        //消息展开
        //this.clearNotiNum();
        this.refAkarninfo();
        this.flag = true;
        this.$nextTick(function () {
          var msgBtn = document.getElementById("msgBtn"),
            msgHead = document.getElementsByClassName("msgBox")[0],
            func2 = moveElement.add(msgBtn, msgHead); //为【msgBtn】添加移动功能，【msgHead】为鼠标拖动区域
          msgHead.onmousedown = function () {
            msgHead.onmousedown = null;
          };
        });
      }
    },
    // 报警列表请求
    refAkarninfo() {
      let that = this;
      this.$req.post("", api.url_alarm_info_list, function (_r, _x) {
        if (_r.success == true) {
          if (_r.data) {
            that.alarmInfo = _r.data;
            that.Alength = that.alarmInfo.length;
          }
        }
      });
    },
    rowClassName: function (row, index) {
      if (index % 2 == 0) {
        return "ivu-table-stripe-even";
      } else return "ivu-table-stripe-odd";
    },
  },
  mounted() {
    this.refAkarninfo();
    var that = this;
    this.$nextTick(function () {
      var msgBtn = document.getElementById("msgBtn"),
        msgIcon = document.getElementsByClassName("msgIcon")[0],
        func2 = moveElement.add(msgBtn, msgIcon); //为【msgBtn】添加移动功能，【msgHead】为鼠标拖动区域
      msgIcon.onmousedown = function () {
        msgIcon.onmousedown = null;
      };
    });
    // 将方法引入到全局中
    window["refAkarninfo"] = () => {
      that.refAkarninfo();
    };
  },
};
</script>

<style scoped>
#msgBtn {
  position: absolute;
  right: 0;
  top: 45%;
  z-index: 9999999;
}

#helloBar {
  width: 60px;
  height: 40px;
  overflow: hidden;
}

.msgIcon {
  position: absolute;
  top: 0;
  right: 0;
  width: 48px;
  height: 40px;
  overflow: hidden;
  -webkit-border-radius: 20px 0 0 20px;
  -moz-border-radius: 20px 0 0 20px;
  border-radius: 20px 0 0 20px;
  background: #0794ff;
}

.deep .msgIcon {
  background: #003d7c;
}

.msgBox {
  position: absolute;
  top: 0;
  right: 0;
  width: 300px;
  height: 360px;
  background: #fff;
  -webkit-border-radius: 5px 0px 0px 5px;
  -moz-border-radius: 5px 0px 0px 5px;
  border-radius: 5px 0px 0px 5px;
  z-index: 99;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 30px 1px;
}

.deep .msgBox {
  background: #143f6c;
}

.msgBack {
  margin: 4px 10px 4px 4px;
  width: 32px;
  height: 32px;
  -webkit-border-radius: 100%;
  -moz-border-radius: 100%;
  border-radius: 100%;
  background: #fff;
  float: left;
  cursor: pointer;
}

.deep .msgBack {
  background: #006dc1;
}

.msgBack > i,
.msgIcon > i {
  width: 32px;
  height: 32px;
  float: left;
  background: url("../../../static/img/notice/icon_msg.png") center no-repeat;
  -webkit-background-size: 26px;
  background-size: 26px;
  cursor: pointer;
}

.iconMsg {
  color: #0794ff;
}

.deep .iconMsg {
  color: #fff;
}

.content-bottom > ul {
  overflow: hidden;
}

.content-bottom > ul > li {
  width: 30%;
  float: left;
  overflow: hidden;
  margin: 0 1.5%;
}

.data-content-ol > li {
  float: left;
  width: 100%;
  overflow: hidden;
  padding: 5px 10px;
  cursor: pointer;
}

.data-content-ol span,
.data-content-ol p,
.data-content-ol b {
  font-size: 12px;
  float: left;
  font-family: "PingFang SC";
  line-height: 20px;
}

.data-content-ol span {
  margin: 0 20px 0 5px;
}

.fa-icon > i {
  width: 12px;
}

.data-content-ol p,
.data-content-ol b {
  color: #02ffff;
}

.data-content-ol b {
  font-weight: normal;
  float: right;
}

.infoLeft {
  width: 50px;
  height: 100%;
  background: #93d0ff;
  -webkit-border-radius: 5px 0 0 5px;
  -moz-border-radius: 5px 0 0 5px;
  border-radius: 5px 0 0 5px;
  float: left;
}

.deep .infoLeft {
  background: #0a2c53;
}

.infoLeft > ul {
  width: 100%;
  overflow: hidden;
}
.liClass {
  background: #167fff;
}
.infoLeft li {
  width: 100%;
  height: 80px;
  cursor: pointer;
}

.infoLeft li:nth-child(1) {
  -webkit-border-radius: 5px 0 0 0;
  -moz-border-radius: 5px 0 0 0;
  border-radius: 5px 0 0 0;
}

.infoLeft i {
  float: left;
  width: 18px;
  height: 18px;
  margin: 18px 16px 6px 16px;
}

.infoLeft p {
  width: 100%;
  float: left;
  font-size: 14px;
  color: #fff;
  font-family: "PingFang SC";
}

.infoLeft .infoSelect {
  background: #0794ff;
}

.deep .infoLeft .infoSelect {
  background: #031c3e;
}

.flod {
  width: 30px;
  height: 30px;
  display: inline-block;
  margin: 10px;
  position: absolute;
  bottom: 10px;
  left: 0;
  cursor: pointer;
}

.msgIcon > p {
  line-height: 40px;
  font-size: 14px;
  color: #fff;
  position: absolute;
  top: 0;
  right: 4px;
}

.infoRight {
  width: 250px;
  height: 100%;
  overflow-y: auto;
  float: left;
}

.infoRight > li {
  margin: 10px 15px;
  width: 220px;
  background: #f5f9ff;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  padding: 8px 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.deep .infoRight > li {
  background: #0a2c53;
}

.infoRight .poptip,
.infoRight b {
  font-weight: normal;
  text-align: left;
  width: 100%;
  float: left;
  font-size: 14px;
  color: #000;
  line-height: 14px;
  font-family: "PingFang SC";
}

.infoRight .poptip {
  overflow: hidden;
  width: 100%;
}

.poptip p {
  width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}

.poptip p:hover {
  text-decoration: underline;
}

.infoRight .poptip h1 {
  float: right;
}

.deep .infoRight .poptip,
.deep .infoRight b {
  color: #fff;
}

.link {
  width: 100%;
  float: left;
  overflow: hidden;
  margin: 10px 0 0 0;
}

.link > span {
  float: left;
  color: #000;
}

.link > a {
  float: left;
  text-decoration: underline;
  cursor: pointer;
}

.infoRight b {
  font-size: 12px;
  margin-top: 10px;
  color: #bbb;
}

.infoRight i {
  height: 100%;
  width: 3px;
  background: #0794ff;
  -webkit-border-radius: 0px 3px 3px 0px;
  -moz-border-radius: 0px 3px 3px 0px;
  border-radius: 0px 3px 3px 0px;
  position: absolute;
  right: 0;
  top: 0;
}
</style>
<style>
.msgIcon .ivu-badge-dot {
  top: 3px;
  right: -1px;
}

.msgIcon .ivu-badge-count {
  height: 12px;
  min-width: 12px;
  line-height: 12px;
  top: -2px;
  padding: 0;
  border-radius: 100%;
  border: none;
}

.poptip > .ivu-poptip-rel {
  width: 100%;
}
.btnYD {
  background-color: #0794ff;
  color: #fff;
  border: none;
  position: absolute;
  left: 5px;
  width: 40px;
  border: 1px solid #fff;
  height: 45px;
  border-radius: 5px;
  font-size: 14px;
  bottom: 70px;
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/notification/notificationBar.vue